import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function G() {
    const { useLang, useState, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.prelaunch');
    const [showVideo, setShowVideo] = useState('');

    const PlayIcon = () => (
        <svg className="play-icon" width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M56.6484 16.1346C56.3498 14.9418 55.7418 13.849 54.8858 12.9665C54.0297 12.084 52.9559 11.443 51.7729 11.1083C47.4502 10.0527 30.1598 10.0527 30.1598 10.0527C30.1598 10.0527 12.8693 10.0527 8.54667 11.2088C7.3636 11.5435 6.2898 12.1845 5.43375 13.067C4.57769 13.9496 3.96969 15.0424 3.67116 16.2351C2.88005 20.6219 2.49308 25.0721 2.51511 29.5296C2.48691 34.0208 2.87391 38.5049 3.67116 42.9247C4.00028 44.0804 4.6219 45.1316 5.47596 45.9769C6.33002 46.8222 7.38766 47.4329 8.54667 47.75C12.8693 48.906 30.1598 48.906 30.1598 48.906C30.1598 48.906 47.4502 48.906 51.7729 47.75C52.9559 47.4153 54.0297 46.7743 54.8858 45.8917C55.7418 45.0092 56.3498 43.9164 56.6484 42.7237C57.4334 38.3699 57.8203 33.9536 57.8044 29.5296C57.8326 25.0385 57.4456 20.5544 56.6484 16.1346Z"
                fill="#FF0200"
            />
            <path d="M24.5039 37.7475L38.9545 29.5295L24.5039 21.3115V37.7475Z" fill="white" />
        </svg>
    );

    return (
        <div id="delta-pro-ultra-prelaunch-G" className={`delta-pro-ultra-G ${css['delta-pro-ultra-G']}`}>
            <div className="text-box">
                <p className="title">
                    {t.rich('secG_title', {
                        n: (n: string) => <span className="no-wrap">{n}</span>,
                    })}
                </p>
            </div>
            <div className="youtube-box">
                <div className={`youtube-img`}>
                    <div className="img-box" onClick={() => setShowVideo('https://www.youtube.com/embed/WDGzPCrw7FY?si=huu8Vyr58phWYK_d')}>
                        <EFPicture src={'/responsive/picture/delta-pro-ultra/prelaunch/7.jpg'} alt={t('secG_desc')} />
                        <PlayIcon />
                    </div>
                    <p className="desc">{t('secG_desc')}</p>
                </div>
                <div className="youtube-double">
                    <div className="youtube-item">
                        <div className="img-box" onClick={() => setShowVideo('https://www.youtube.com/embed/qqFkljjsaAs?si=3adhPkoXJKavq6ob')}>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/prelaunch/7_1.jpg'} alt={t('secG_desc1')} />
                            <PlayIcon />
                        </div>
                        <p className="desc">{t('secG_desc1')}</p>
                    </div>
                    <div className="youtube-item">
                        <div className="img-box" onClick={() => setShowVideo('https://www.youtube.com/embed/E3loAZhEif8?si=Kx0u-NDpowNHWZ1h')}>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/prelaunch/7_2.jpg'} alt={t('secG_desc2')} />
                            <PlayIcon />
                        </div>
                        <p className="desc">{t('secG_desc2')}</p>
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={Boolean(showVideo)}
                source={showVideo}
                onClose={() => setShowVideo('')}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
